<template>
	<div class="user-bar">
		<div class="mobile-menu-button">
			<font-awesome-icon  icon="fa-bars" size="2xl" />
		</div>
		<div class="logo-container">	
			<span>				
				<LottieAnimation
					ref="anim"
					:animationData="require('@/assets/img/logoright-logo.json')"
					:loop="true"
					:autoPlay="true"
					/>					
			</span>
			
			<!-- <span class="collapse-expand-menu">
				<font-awesome-icon class="collapse-menu-icon" icon="fa-angle-left" size="lg" />
				<font-awesome-icon class="expand-menu-icon" icon="fa-angle-right" size="lg" />
			</span>						 -->
		</div>
		<div class="user-bar-dataline">
			<span class="top-link" @click="back()">&laquo; &nbsp;Назад</span>
			<span><img :src="calendarIcon" class="user-bar-time-icon"> {{ timestampDate }} <img :src="clockIcon" class="user-bar-time-icon"> {{ timestampTime }}</span>										
			<span class="help">
				<span></span>				
				<span v-if="loggedInUserData.user_id" class="user-name-line">					
					<img class="user-bar-icon" :src="require('@/assets/img/user.svg')" />{{loggedInUserData.first_name ? loggedInUserData.last_name + " " + loggedInUserData.first_name + " " + loggedInUserData.patronymic : loggedInUserData.company_title}}			
				</span>
				<span v-if="loggedInUserData.user_id" class="top-link top-button top-button-logout" @click="logout()">Выход из кабинета<img :src="require('@/assets/img/logout.svg')"></span>
				<span v-if="!loggedInUserData.user_id" class="top-link top-button" @click="goToSignUp()">Регистрация</span>
				<span v-if="!loggedInUserData.user_id" class="top-link top-button top-button-login" @click="goToLogin()"><img :src="require('@/assets/img/login.svg')">Вход</span>						
			</span>
		</div>		
	</div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import dateFormat from "dateformat"
import LottieAnimation from 'lottie-web-vue'

export default {
	
	name: 'UserBar',

	components: {
		LottieAnimation
	},

	props: ["login"],

	watch: {		
		login: function(val){
			console.log("Login in UserBar", val)
			this.getLoggedInUserData()
		}
	},

	data() {
		return {
			loggedInUserData: JSON.parse(localStorage.getItem('app_user_data')) || false,
			timestampDate: "",
			timestampTime: "",
			timer: null,
			clock: null,
			inactivity: null,
			mouseMoveTimeout: Number(localStorage.getItem('app_timeout')),	
			clockIcon: require('@/assets/img/clock.svg'),
			calendarIcon: require('@/assets/img/calendar.svg')					
		}
	},
	
	mounted() {
		this.startTimers()
		$("body").mousemove(() => {			
			clearTimeout(this.inactivity)
			//console.log("Mouse move timeout cleared.")
			this.inactivity = setTimeout(this.logoutByInactivity, this.mouseMoveTimeout)
		})		
		$(".nav-link").click(() => {
			if(window.innerWidth < 992){
				$(".sidebar-left").fadeOut(300)
			}	
		})			
		$(".mobile-menu-button").click(() => {
			$(".sidebar-left").fadeIn(300)
		})
		$(".mobile-menu-button-close").click(() => {
			$(".sidebar-left").fadeOut(300)
		})
		$(".mobile-button").click(() => {
			$(".sidebar-left").fadeOut(300)
		})			
				
	},

	beforeDestroy() {
		clearInterval(this.timer)
		clearInterval(this.clock)
		clearTimeout(this.inactivity)
	},

	methods: {

		back(){
			window.history.back()
		},

		forward(){
			window.history.forward()
		},

		startTimers(){
			this.timer = setInterval(this.updateUserData, 3000)
			this.clock = setInterval(this.getNow, 1000)
			this.inactivity = setTimeout(this.logoutByInactivity, this.mouseMoveTimeout)
		},
		
		getLoggedInUserData() {		
			const userObject = JSON.parse(localStorage.getItem('app_user_data')) || false
			const userId = userObject ? parseInt(userObject.user_id) : 0	
			if(userId > 0){
				let getUrl = `/users/${userId}`
				if(window.menubar.visible){
					getUrl = `/users/${userId}&update_activity=1`
				}
				axios({ url: getUrl, method: 'GET' })
				.then(response => {
					if(response.status == 200 && response.data && response.data.data){
						localStorage.setItem('app_user_data', JSON.stringify(response.data.data))
						this.loggedInUserData = response.data.data
					}else{
						console.log("Error: Wrong status code!")										
						this.logout()
					}					
				})
				.catch(error => {	
					console.log("Error: " + error)										
					this.logout()					
				})
			}else{
				console.log("Error: No user ID!")
				this.logout()				
			}
		},

		logoutByInactivity(){
			console.log("Logged out by inactivity!")
			this.logout()
		},
		
		logout(){
			localStorage.removeItem('app_user_data')
			localStorage.removeItem('app_token')
			delete axios.defaults.headers.common['Authorization']
			this.loggedInUserData = []
			this.$emit('onLogout', true)
			if(this.$router.currentRoute.path != "/login"){
				this.$router.push("/login")
			}			
		},
		
		goToSignUp(){
			if(this.$router.currentRoute.path != "/signup"){
				this.$router.push("/signup")
			}
		},

		goToLogin(){
			if(this.$router.currentRoute.path != "/login"){
				this.$router.push("/login")
			}
		},

		getNow() {
			const now = new Date();
			this.timestampDate = dateFormat(now, "dd.mm.yyyy")
			this.timestampTime = dateFormat(now, "HH:MM:ss")							
		}		
		
	}

}
</script>

<style scoped>

.logout {
	color: #fff; 
	text-decoration: underline;
	cursor: pointer;
}

.user-bar-icon {
	font-size: 11px;
	display: inline-block;
	margin-bottom: 1px;
	margin-right: 5px;
}	



</style>